var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('polygon',{attrs:{"stroke":"currentColor","stroke-width":"1.5","points":"12 4.62 13.91 10.5 20.09 10.5 15.09 14.13 17 20.01 12 16.38 7 20.01 8.91 14.13 3.91 10.5 10.09 10.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }